import { setModels } from "../../../store/slices/modelSlice";
import { removeUser } from "../../../store/slices/userSlice";
import { errorToast } from "../../methods/toast";
import { $authHost } from "../http";

export const getModelAiList = () => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get("/modelai/list");

      if (data.code === 200) {
        if (data.modelAI) {
          dispatch(setModels(data.modelAI));
        }
      } else {
        errorToast("Ошибка при получении списка моделей.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера. Попробуйте позже.");
        }
      } else if (error.request) {
        errorToast("Проблемы с подключением. Проверьте интернет.");
      } else {
        errorToast("Произошла неизвестная ошибка.");
      }

      console.log("getModelAiList error: ", error);
    }
  };
};
